import { Component, OnDestroy } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { Subscription, filter, map } from "rxjs";
import { PageModel, SiteConfigState } from "src/app/models/site.config.models";
import { BrandingService } from "src/app/services/branding.service";
import { DynamicPageService } from "src/app/services/dynamic-page.service";
import { OfferDetailsService } from "src/app/services/offer-details.service";
import { CpbSection, OfferDetailsSection, PageType, SectionType, TextAndMediaSection, TextSection, Tile } from "talos-careers-page-library";
import { CallToActionService } from "./services/call-to-action.service";
import { LocalStorage } from "src/app/constants/local-storage";

@Component({
    selector: 'dynamic-page',
    templateUrl: './dynamic-page.page.html',
    standalone: false
})

export class DynamicPagePage implements OnDestroy {
  public sections: CpbSection[] = [];
  public pageType = PageType.HOME;

  public siteConfig: SiteConfigState = {} as SiteConfigState;
  public subscription$: Subscription = new Subscription;

  constructor(
    private dynamicPageService: DynamicPageService,
    private brandingService: BrandingService,
    private router: Router,
    private offerDetailsService: OfferDetailsService,
    private callToActionService: CallToActionService
  ) {
    if(!localStorage.getItem(LocalStorage.ACCESS_TOKEN)){
      this.router.navigate(['invalid']);
    }

    this.tryUpdateDynamicPageOnUrlChange();
    this.subscription$.add(brandingService.branding$.subscribe(b => this.onGetBranding(b)));
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  private tryUpdateDynamicPageOnUrlChange(): void {
    this.subscription$.add(
      this.router.events.pipe(
        filter(event => event instanceof NavigationStart),
        map(event => event as NavigationStart),
      )
        .subscribe((navigationStart) => this.trySetPageFromUrl(navigationStart.url))
    );
  }

  private trySetPageFromUrl(url: string): PageModel | null {
    const page = this.dynamicPageService.tryGetPage(this.siteConfig, this.siteConfig.pageModels, url);
    if (page) {
      this.setSectionsWithRoleDetailsData(page.sections);
      this.pageType = page.pageType;
    }

    return page;
  }

  private onGetBranding(siteConfig: SiteConfigState) {
    this.siteConfig = siteConfig;

    const page = this.dynamicPageService.tryGetPage(this.siteConfig, this.siteConfig.pageModels, window.location.pathname);
    if (page) {
      this.setSectionsWithRoleDetailsData(page.sections);
      this.pageType = page.pageType;
    }
    else {
      this.router.navigateByUrl('/');
    }
  }

  //#region OfferDetails
  public setSectionsWithRoleDetailsData(sections: CpbSection[]) {
    const defaultOfferDetailsSections = sections.filter(section => section.sectionType === SectionType.OFFER_DETAILS) as OfferDetailsSection[];
    if (defaultOfferDetailsSections.length) {
      this.subscription$.add(this.offerDetailsService.getSectionsWithData(sections, defaultOfferDetailsSections).subscribe(data => {
        this.sections = data;
      }));
    } else {
      this.sections = sections;
    }
  }
  //#endregion OfferDetails

  //#region Text and Media
  public textAndMediaOnCallToActionPageClicked(event: TextSection | TextAndMediaSection | Tile): void {
    this.callToActionService.tryNavigateToPage(event.callToAction, this.siteConfig!);
  }
  //#endregion Text and Media
}
